// frontend\packages\shared\ui\src\utils\getInitials.js
export default function getInitials(name = "") {
  if (!name) return "";
  const words = name.trim().split(/\s+/);
  const initials = words
    .slice(0, 2)
    .map((w) => w[0])
    .join("");
  return initials.toUpperCase();
}
